import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Drawer from 'components/form-components/Drawer';
import TicketEditForm from './TicketEditForm';
import { CallAPI } from 'actions/General';

const TicketEditModal = ({ selectedRecordId, handleClose, actionsCallBack }) => {
  const [ticketData, setTicketData] = useState(null);
  const [companyFields, setCompanyFields] = useState([]);

  const urlsRef = useRef({});

  const fetchTicketDetail = async () => {
    const result = await CallAPI('GET_TICKET_DETAIL', null, selectedRecordId, null);
    if (result.status) {
      const data = result.data;

      if (data.companyFieldsData && Object.keys(data.companyFieldsData).length) {
        const response = await CallAPI('GET_ALL_COMPANY_FIELDS', {});
        if (response.status) {
          setCompanyFields(response.data);
        }
      }

      const urls = {};
      const bulkMediaPayload = [];
      for (const media of data.media) {
        bulkMediaPayload.push({
          imageName: media.imageName,
          mediaId: media._id,
          mediaType: media.mediaType,
          folderType: media.folderType,
          ticketId: media.ticketId,
        });
      }

      if (bulkMediaPayload.length) {
        const response = await CallAPI('GET_GENERIC_BULK_DOWNLOAD_MEDIA_REDIRECT_URL', {
          medias: bulkMediaPayload,
        });
        if (response.status) {
          response.data.forEach((item) => {
            urls[item._id] = item.url;
          });
        }
      }
      urlsRef.current = urls;

      setTicketData(data);
    }
  };

  useEffect(() => {
    fetchTicketDetail();
  }, []);

  return (
    <div className=''>
      <Drawer
        title='text_ticket_detail'
        handleClose={handleClose}
        classes='theme-font-inter-regular'
        style={{
          width: '35rem',
        }}
        headerClasses='p-3 border-bottom-grey-10-h-1 theme-font-inter-semi-bold theme-size-1_5 theme-text-black-1'
        bodyClasses=''
        bodyComponent={
          <TicketEditForm
            selectedRecord={ticketData}
            mediaUrls={urlsRef.current}
            actionsCallBack={actionsCallBack}
            companyFieldList={companyFields}
            handleClose={handleClose}
          />
        }
      />
    </div>
  );
};

TicketEditModal.propTypes = {
  selectedRecordId: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  actionsCallBack: PropTypes.func.isRequired,
};

export default TicketEditModal;
